export default __webpack_public_path__ + "assets/hero-small.2853ad22.jpg";